<template>
  <v-form ref="form">
    <v-layout row wrap style="margin-top: 35px">
    <v-flex xs12 class="text-center">
      <h2>Contact</h2>
    </v-flex>
    <v-flex xs12 sm12 md6>
    <v-layout row wrap>
        <v-radio-group v-model="contact.sexe" row>
          <v-flex xs12 sm6>
            <v-radio label="Männlich" value="Masculin"></v-radio>
          </v-flex>
          <v-flex xs12 sm6>
            <v-radio label="Weiblich" value="Féminin"></v-radio>
          </v-flex>
        </v-radio-group> 
        <v-flex xs12>
          <v-combobox filled v-model="contact.designation" label="Bezeichnung" v-bind:items="contact.sexe=='Masculin' ? designMasc : designFem" :menu-props="{maxHeight:'auto'}"></v-combobox>
        </v-flex>
        <v-flex xs12>
          <v-combobox filled v-model="contact.titre" label="Anrede" v-bind:items="contact.sexe=='Masculin' ? titreMasc : titreFem" :menu-props="{maxHeight:'auto'}"></v-combobox>
        </v-flex>
        <v-flex xs12>
          <v-text-field :rules="requiredField" filled label="Vorname" v-model="contact.prenom"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field filled label="Name" v-model="contact.nom"></v-text-field>
        </v-flex>

        <v-flex xs6>
        <v-autocomplete :loading="isLoadingAdress" filled return-object clearable hide-no-data :items="itemsAdr" label="Suche Adresse" item-text="descript" :search-input.sync="autoAdress" v-model="adresseSearch" @change="adrSelected(adresseSearch)"></v-autocomplete>
        </v-flex>
        <v-flex xs6>
          <v-text-field filled v-model="contact.adresse" label="Adresse"></v-text-field>
        </v-flex>
        <v-flex xs3>
        <v-text-field filled v-model="contact.cp" label="PLZ" v-mask="maskCp"></v-text-field>
        </v-flex>
        <v-flex xs9>
        <v-text-field filled v-model="contact.loc" label="Ort"></v-text-field>
        </v-flex>
    </v-layout>
    </v-flex>

    <v-flex xs12 sm12 md6>
    <v-layout row wrap>
        <v-flex xs6>
            <v-text-field filled masked v-model="contact.tel1" type="tel" prepend-icon="mdi-phone" label="Telefonnummer 1" v-mask="maskTel"></v-text-field>
        </v-flex>
        <v-flex xs6>
            <v-text-field filled masked v-model="contact.tel2" type="tel" prepend-icon="mdi-phone" label="Telefonnummer 2" v-mask="maskTel"></v-text-field>
        </v-flex>
        <v-flex xs12>
            <v-text-field :rules="emailRules" filled v-model="contact.mail1" type="email" prepend-icon="mdi-email" label="E-mail 1"></v-text-field>
        </v-flex>
        <v-flex xs12>
            <v-text-field :rules="emailRules" filled v-model="contact.mail2" type="email" prepend-icon="mdi-email" label="E-mail 2"></v-text-field>
        </v-flex>
        <v-flex xs12>
            <v-textarea outline v-model="contact.remarque" label="Bemerkungen"></v-textarea>
        </v-flex>
        <v-flex xs4>
            <v-icon class="green--text">mdi-currency-usd</v-icon>
            <v-checkbox v-model="contact.facture" label="Rechnung" :disabled="checkFact"></v-checkbox>
        </v-flex>
        <v-flex xs4>
            <v-icon class="purple--text">mdi-gavel</v-icon>
            <v-checkbox v-model="contact.legal" label="Legal" :disabled="checkLeg"></v-checkbox>
        </v-flex>
        <v-flex xs4>
            <v-icon class="orange--text">mdi-flare</v-icon>
            <v-checkbox v-model="contact.celebrant" label="Zelebrant" :disabled="checkCele"></v-checkbox>
        </v-flex>
        <v-flex xs12 class="text-center">
          <v-btn large color="primary" :loading="saveLoad" :disabled="saveLoad" @click.native="save()">Speichern</v-btn>
        </v-flex>
    </v-layout>
    </v-flex>
    <v-btn fab fixed color="warning" :loading="saveLoad" :disabled="saveLoad" @click.native="save()"><v-icon>mdi-content-save</v-icon></v-btn>
    <v-dialog eager v-model="dialog" max-width="250px">
      <v-card>
        <v-card-title>
          <span class="headline">Hausnummer</span>
        </v-card-title>
        <v-card-text>
          <v-text-field ref="numRue" label="Nummer" v-model="numero"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="numChoisi(numero)">Ok</v-btn>
          <v-btn @click="dialog = false">Schliessen</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-layout>
</v-form>
</template>
<script>
    import {ajax, ajax_post} from '../../public/global.js'
    export default {
      data(){
        return{
          contact: {
            sexe: 'Masculin',
            designation: '',
            titre: '',
            prenom: '',
            nom:'',
            adresse: '',
            cp: '',
            loc: '',
            tel1: '',
            tel2: '',
            mail1: '',
            mail2: '',
            facture: false,
            legal: false,
            celebrant: false,
            remarque: ''
          },
          titreMasc: [
            'Herr'
          ],
          titreFem: [
            'Frau'
          ],
          designMasc: [
            'sein Ehemann',
            'sein Sohn',
            'sein Bruder',
            'sein Vater',
            'sein Onkel',
            'Bestattungsversicherungsvertrag',
          ],
          designFem: [
            'seine Frau',
            'seine Tochter',
            'seine Schwester',
            'seine Mutter',
            'seine Tante',
            'Bestattungsversicherungsvertrag'
          ],
          adrReturn: [],
          autoAdress: null,
          adresseSearch:'',
          dialog: false,
          numero: '',
          isLoadingAdress: false,
          saveLoad: false,
          comboConf: false,
          maskTel: "### ### ## ##",
          maskCp: "####",
          checkFact: false,
          checkLeg: false,
          checkCele: false,
          itemsAdr: [],
          emailRules: [
            v => !v || /.+@.+\..+/.test(v) || "E-mail ungültig !",
          ],
          requiredField: [
            v => !!v || "Dieses Textfeld ist erforderlich !"
          ]
        }
      },
      methods: {
        adrSelected(adrSelected){
          if(adrSelected != null){
            this.contact.adresse = adrSelected.adresse
            this.contact.cp = adrSelected.cp
            this.contact.loc = adrSelected.loc
            this.dialog = true
            this.$nextTick(this.$refs.numRue.focus)
          }
        },
        numChoisi(numero){
          this.contact.adresse = this.contact.adresse + ' ' + numero
          this.dialog = false
        },
        fetchData () {
          ajax_post(`/PHP/ajax/returnContact.php`,`id=${this.$route.params.idContact}&token=${this.$token()}`).then((response) =>{
            let rep = JSON.parse(response)
            if(!rep.error){
              let contactRecup = rep.data
              this.contact.sexe = contactRecup.sexe
              this.contact.designation = contactRecup.designation
              this.contact.titre = contactRecup.titre
              this.contact.prenom = contactRecup.prenom
              this.contact.nom = contactRecup.nom
              this.contact.adresse = contactRecup.adresse
              this.contact.cp = contactRecup.cp
              this.contact.loc = contactRecup.loc
              this.contact.tel1 = contactRecup.tel1
              this.contact.tel2 = contactRecup.tel2
              this.contact.mail1 = contactRecup.mail1
              this.contact.mail2 = contactRecup.mail2
              this.contact.facture = (contactRecup.facture == 1 ? true : false)
              this.contact.legal = (contactRecup.legal == 1 ? true : false)
              this.contact.celebrant = (contactRecup.celebrant == 1 ? true : false)
              this.contact.remarque = contactRecup.remarque
            }else{
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        },
        saveNext(){
          this.saveLoad = true
          ajax_post(`/PHP/ajax/saveContact.php`, `idcontact=${this.$route.params.idContact}&id=${this.$route.params.id}&token=${this.$token()}&sexe=${this.contact.sexe}&designation=${this.contact.designation}&titre=${this.contact.titre}&prenom=${this.contact.prenom}&nom=${this.contact.nom}&adresse=${this.contact.adresse}&cp=${this.contact.cp}&localite=${this.contact.loc}&tel1=${this.contact.tel1}&tel2=${this.contact.tel2}&mail1=${this.contact.mail1}&mail2=${this.contact.mail2}&remarque=${this.contact.remarque}&facture=${(this.contact.facture == true ? 1 : 0)}&legal=${(this.contact.legal == true ? 1 : 0)}&celebrant=${(this.contact.celebrant == true ? 1 : 0)}`).then((response)=>{
            let rep = JSON.parse(response)
            if(!rep.error){
              this.saveLoad = false
              this.$root.$emit('myinfo',{title: "Serenity", msg: "Kontakt gespeichert !", color: ""})
              this.$router.push({ name: 'contact' })
            }else{
              this.saveLoad = false
              this.$root.$emit('myinfo',{title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        },
        save(){
          if(this.$refs.form.validate()){
            setTimeout(() => {
              this.saveNext()
            }, 0)
          }
        },
        querySelection(v){
          this.isLoadingAdress = true
          ajax("/PHP/ajax/returnAdress.php?val=" + v).then((response) =>{
            let adrReturn = JSON.parse(response)
            //on ajoute le descriptif pour voir l'adresse et la localité dans la liste déroulante 
            this.itemsAdr = adrReturn.map(res => ({...res, descript: res.adresse + " / " + res.loc}))
            this.isLoadingAdress = false
          })
        }
      },
      watch: {
        '$route': 'fetchData',
        autoAdress(val){
          val && val.length > 3 && val !== this.contact.adresse && this.querySelection(val)
        }
      },
      created () {
        this.fetchData()
      }
    }
</script>